import {Badge, BadgeColorScheme} from 'platform/components';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

const PODIUM_COLOR_SCHEME: Record<number, BadgeColorScheme> = {
  1: 'yellow',
  2: 'neutral',
  3: 'orange',
};

interface SalesLeagueRankProps extends RequiredTestIdProps {
  rank: number;
}

export function SalesLeagueRank(props: SalesLeagueRankProps) {
  return (
    <Badge
      value={props.rank}
      variant="subtle"
      size="small"
      colorScheme={PODIUM_COLOR_SCHEME[props.rank] ?? 'neutral'}
      data-testid={suffixTestId('rank', props)}
    />
  );
}
